jQuery( document ).ready( function( $ ) {

	// scroll to anchor point js
	$( 'a[href*="#"]:not([href="#"])' ).click( function() {

		if ( location.pathname.replace( /^\//,'' ) == this.pathname.replace( /^\//,'' ) && location.hostname == this.hostname ) {
			let target = $( this.hash );
			target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) +']' );

			if ( target.length ) {
				$( 'html, body' ).animate( { scrollTop: target.offset().top } , 1000 );

				return false;
			}
		}
	} );

	function isMobileView() {
		return window.innerWidth <= 1023;
	}

	function closeSearch() {
		$('body').removeClass('show-search show-menu');
	}

	// Function to close all header dropdowns and reset to initial state
	function closeAllHeaderDropdowns() {
		if (!isMobileView() || !$('body').hasClass('show-main-menu')) {
			$('.header__nav-container__edition .menu-item-has-children.active')
				.not('.layout__screen-overlay--main-menu .menu-item-has-children')
				.removeClass('active')
				.children('.sub-menu').slideUp(300);

			$('.header__login-menu .menu-item-has-children.active')
				.not('.layout__screen-overlay--main-menu .menu-item-has-children')
				.removeClass('active')
				.children('.sub-menu').slideUp(300);
		}
	}

	$(document).ready(function() {

		// Function to initialize login and edition menu behaviors
		function initLoginAndEditionMenus() {
			$('.header__login-menu .menu-item-has-children').off('click mouseenter mouseleave');
			$('.header__nav-container__edition .menu-item-has-children').off('click mouseenter mouseleave');
			$('.header__login-menu .menu-item-has-children > a').off('click mouseenter mouseleave');
			$('.header__nav-container__edition > .menu-item-has-children > a').off('click mouseenter mouseleave');

			if (isMobileView()) {
				$('.header__login-menu .menu-item-has-children > a').on('click', function(event) {
					event.preventDefault();
					event.stopPropagation();

					let $parent = $(this).parent();

					if ($parent.hasClass('active')) {
						$parent.removeClass('active');
						$parent.children('.sub-menu').slideUp(300);
					} else {
						// Close search when opening menu
						closeSearch();

						// Close the other menu first
						$('.header__nav-container__edition .menu-item-has-children.active, .header__login-menu .menu-item-has-children.active')
							.not($parent)
							.removeClass('active')
							.children('.sub-menu').slideUp(300);

						$parent.addClass('active');
						$parent.children('.sub-menu').slideDown(300);
					}
				});

				$('.header__nav-container__edition > .menu-item-has-children > a').on('click', function(event) {
					event.preventDefault();
					event.stopPropagation();

					let $parent = $(this).parent();

					if ($parent.hasClass('active')) {
						$parent.removeClass('active');
						$parent.children('.sub-menu').slideUp(300);
					} else {
						// Close search when opening menu
						closeSearch();

						// Close the other menu first
						$('.header__nav-container__edition .menu-item-has-children.active, .header__login-menu .menu-item-has-children.active')
							.not($parent)
							.removeClass('active')
							.children('.sub-menu').slideUp(300);

						$parent.addClass('active');
						$parent.children('.sub-menu').slideDown(300);
					}
				});
			} else {
				// Desktop: Hover handlers
				$('.header__nav-container__edition .menu-item-has-children').on('mouseenter', function() {
					closeSearch();
					$(this).addClass('active');
					$(this).children('.sub-menu').stop(true, true).slideDown(200);
				}).on('mouseleave', function() {
					$(this).removeClass('active');
					$(this).children('.sub-menu').stop(true, true).slideUp(200);
				});

				$('.header__login-menu .menu-item-has-children').on('mouseenter', function() {
					closeSearch();
					$(this).addClass('active');
					$(this).children('.sub-menu').stop(true, true).slideDown(200);
				}).on('mouseleave', function() {
					$(this).removeClass('active');
					$(this).children('.sub-menu').stop(true, true).slideUp(200);
				});
			}
		}

		function initDesktopHoverBehavior() {
			if (isMobileView()) {
				return;
			}

			// Ensure submenus appear on hover for main navigation
			$('#menu-main-nav .header__nav-container__bottom-menu__item--has-children').off('mouseenter mouseleave').on('mouseenter', function() {
				$(this).addClass('active');
				$(this).children('.sub-menu').stop(true, true).slideDown(200);
			}).on('mouseleave', function() {
				$(this).removeClass('active');
				$(this).children('.sub-menu').stop(true, true).slideUp(200);
			});

			// Adjust submenu positions for main navigation
			$('#menu-main-nav .header__nav-container__bottom-menu__item--has-children').each(function() {
				$(this).find('.sub-menu').each(function() {
					if ($(this).offset().left + $(this).outerWidth() > $(window).width()) {
						$(this).removeClass('removeAttr').css({
							left: 'auto',
							right: '0'
						});
					}
				});
			});
		}		function initMobileSpecificChanges() {
			if (!isMobileView()) {
				return;
			}

			// Hide all submenus initially
			$('.sub-menu').hide();

			// Add specific handler for mobile menu items
			$('#menu-main-nav .header__nav-container__bottom-menu__item--has-children > a').off('click').on('click', function(event) {
				event.preventDefault();
				let $parent = $(this).parent();

				if ($parent.hasClass('active')) {
					$parent.removeClass('active');
					$parent.children('.sub-menu').slideUp(300);
				} else {
					$parent.siblings('.header__nav-container__bottom-menu__item--has-children').removeClass('active').children('.sub-menu').slideUp(300);
					$parent.addClass('active');
					$parent.children('.sub-menu').slideDown(300);
				}
			});
		}

		if (isMobileView()) {
			initMobileSpecificChanges();
		} else {
			initDesktopHoverBehavior();
		}

		initLoginAndEditionMenus();

		$(window).on('resize', function() {
			if (isMobileView()) {
				initMobileSpecificChanges();
			} else {
				initDesktopHoverBehavior();
			}

			initLoginAndEditionMenus();
		});
	});

	// Hide all submenus initially, including the edition menu
	$('.sub-menu').hide();

	// If mobile menu is already open on page load, ensure proper menu behavior
	if ($('body').hasClass('show-main-menu')) {
		setTimeout(function() {
			// For any already active top-level items, show all their submenus
			$('.layout__screen-overlay--main-menu .header__nav-container__bottom-menu__item.active').each(function() {
				let $firstLevelSubmenu = $(this).children('.sub-menu');
				$firstLevelSubmenu.show();

				$firstLevelSubmenu.find('> li').each(function() {
					let $secondLevelItem = $(this);
					if ($secondLevelItem.find('> .sub-menu').length > 0) {
						$secondLevelItem.addClass('active');
						$secondLevelItem.children('.sub-menu').show();
					}
				});
			});
		}, 300);
	}

	const watchlist_menu_links = $( 'a[href="/deals"]' );
	if ( watchlist_menu_links ) {
		watchlist_menu_links.click( function() {
			localStorage.removeItem( 'deal-search-cache' );
		} );
	}

	const search_menu_links = $( 'a[href="/search"]' );
	if ( search_menu_links ) {
		search_menu_links.click( function() {
			localStorage.removeItem( 'article-search-cache' );
		} );
	}

	/*

	1. menu clicked open
	2. somethin else clicked
		a. Is navigation link
			i. go to that page
		b. is not navigation link
			i. close menu
			ii. remove blocker
	*/


	// listen for all click events on body, we can decide wjat to do with them in the closure
	$( 'body' ).on( 'click', function( e ) {
		var elm = $( e.target );

		if ( elm.hasClass( 'js-toggle-menu' ) ) {
			return;
		}

		if ( elm.is( 'a' ) ) {
			return;
		}

		// if the menu is open, we need to no more tesst on them, if not them they can go on.
		if ( $( 'body' ).hasClass( 'show-main-menu' ) ){
			console.log( 'click2' )
			var elm = $( e.target );
			console.log( elm )

			// if we clicked a link then do as normal
			if ( elm === 'a' ) { /* */ }
			else if ( elm == '.js-toggle-menu' ){
				console.log( 'hello' )
			} else if ( elm.closest( '.layout__screen-overlay--main-menu' ).length ) {
				// clikcked inside the menu
				console.log( 'hey?' )
			} else if( !elm.closest( '.layout__screen-overlay--main-menu' ).length ) {
				console.log( 'hey2?' )
				console.log( elm.closest( '.layout__screen-overlay--main-menu' ).length )
				$( 'body' ).toggleClass( 'show-main-menu' );
				e.preventDefault()
			}
		}

		if ( $( 'body' ).hasClass( 'show-search' ) ) {
			if (
				e.target.id !== 'search-form-field'
				&& e.target.id !== 'search-form-submit'
				&& e.target.id !== 'search-form'
				&& e.target.id !== 'search-form-container'
			) {
				$( 'body' ).removeClass( 'show-search' );
			}
		}

	} );

	// we dont want to prevent a defauklt event here, keep bubbeling as normal
	$( '.js-equal-column-height' ).matchHeight();
	$( '.article__related-articles__tease-news' ).matchHeight();
	$( '.article__recommended-articles__tease-news' ).matchHeight();
	$( '.layout__menu-half-height-of-parent' ).matchHeight();

	$( '.js-toggle-menu' ).on( 'click' , function( event ) {
		event.preventDefault();
		event.stopPropagation();

		// Close search when opening mobile menu
		closeSearch();

		$( 'body' ).toggleClass( 'show-main-menu' );

		// Only close header dropdowns when OPENING mobile menu (to avoid conflicts)
		if ($('body').hasClass('show-main-menu')) {
			$('.header__nav-container__edition .menu-item-has-children.active')
				.not('.layout__screen-overlay--main-menu .menu-item-has-children')
				.removeClass('active')
				.children('.sub-menu').slideUp(300);

			$('.header__login-menu .menu-item-has-children.active')
				.not('.layout__screen-overlay--main-menu .menu-item-has-children')
				.removeClass('active')
				.children('.sub-menu').slideUp(300);

			$('.layout__screen-overlay--main-menu .header__nav-container__bottom-menu__item--non-clickable > a').off('mouseenter mouseleave');

			$('.layout__screen-overlay--main-menu .sub-menu').hide();
			$('.layout__screen-overlay--main-menu .active > .sub-menu').show();
		}
	} );



	$( '.js-toggle-search' ).on( 'click' , function( event ) {
		event.preventDefault();
		event.stopPropagation();
		console.log( 'js toggle search clicked' )

		// Close all header dropdowns when search is toggled
		closeAllHeaderDropdowns();

		$( 'body' ).toggleClass( 'show-search show-menu' );
		$( '#search-form-field' ).focus();
		$( '.header__nav-container__bottom-menu__item--non-clickable' ).removeClass( 'active' );
	} );

	$( '.header__nav-container__bottom-menu__item--non-clickable > a' ).on( 'click' , function( event ) {
		if (!$('body').hasClass('show-main-menu')) {
			event.preventDefault();
			event.stopPropagation();

			var parent = $( this ).parent( '.header__nav-container__bottom-menu__item--non-clickable' );
			parent.siblings().removeClass( 'active' );
			parent.toggleClass( 'active' );

			$( 'body' ).removeClass( 'show-search' );
		}
	} );

	$( '.header__nav-container__bottom-menu__item--non-clickable > a' ).on( 'mouseenter mouseleave' , function( event ) {
		if (!$('body').hasClass('show-main-menu')) {
			event.preventDefault();
			event.stopPropagation();

			var parent = $(this).parent( '.header__nav-container__bottom-menu__item--non-clickable' );
			parent.siblings().removeClass( 'active' );
			parent.toggleClass( 'active' );

			$( 'body' ).removeClass( 'show-search' );
		}
	} );

	$( '.header__nav-container__bottom-menu__item--non-clickable ul' ).on( 'mouseleave' , function() {
		if (!$('body').hasClass('show-main-menu')) {
			event.preventDefault();
			event.stopPropagation();

			$( '.header__nav-container__bottom-menu__item--non-clickable' ).removeClass( 'active' );
		}
	} );

	$( '.layout__screen-overlay__nav__item--non-clickable' ).on( 'click' , function( event ) {
		event.preventDefault();
		event.stopPropagation();
		$( this ).find( '.layout__screen-overlay__nav__item__submenu' ).slideToggle();
	} );

	$( 'button.tabbed-listings__heading' ).on( 'click' , function( event ) {
		event.preventDefault();

		var panel_index = $( this ).index();
		$( this ).siblings().removeClass( 'active' );
		$( this ).addClass( 'active' );

		var panel_to_activate = $( '.tabbed-listings__panel' ).eq( panel_index );
		if ( !panel_to_activate.hasClass( 'active' ) ) {
			panel_to_activate.siblings().removeClass( 'active' );
			panel_to_activate.addClass( 'active' );
		}
	} );

	if ( $( '.article__image-gallery' ).length ) {
		$( '.article__image-gallery' ).owlCarousel( {
			items: 1,
			nav: true
		} );
	}

	$( '.team-page__media' ).each( function() {
		const id = $( this ).attr( 'id' );

		$( '#' + id ).on( 'click' , function () {
			$( '#' + id.replace( '-item' , '-modal' ) ).addClass( 'team-page__modal--show' );
			bodyScrollLock.disableBodyScroll( document.querySelector( 'body' ) );
		} );
	} );

	$( '.team-page__modal-close' ).on( 'click' , function () {
		bodyScrollLock.enableBodyScroll( document.querySelector( 'body' ) );
		$( '.team-page__modal' ).removeClass( 'team-page__modal--show' );
	} );

	$( '.team-page__modal-backdrop' ).on( 'click' , function () {
		bodyScrollLock.enableBodyScroll( document.querySelector( 'body' ) );
		$( '.team-page__modal' ).removeClass( 'team-page__modal--show' );
	} );

	/* Load more posts via AJAX on click button */
	var loadMore = $('#load-more');
	loadMore.on('click', 'button', function (e) {
		var loadMoreBtn = $(e.target);

		$.ajax({
			url: pbc_js.ajax_url,
			type: 'GET',
			data: {
				action: 'pbc_load_more_posts',
				shownArticles: loadMore.data('shown-articles'),
				termId: loadMore.data('term-id'),
				postType: loadMore.data('post-type')
			},
			beforeSend: function(xhr) {
				loadMoreBtn.text('Loading...').prop('disabled', true);
			},
			success: function (response) {
				loadMoreBtn.text('Load More').prop('disabled', false);
				if (response.success) {
					loadMore.before(response.data.html);
					loadMore.data('shown-articles', response.data.shownArticles);
				}
				if (response.finished) {
					loadMore.remove();
				}
				if (response.error) {
					console.log(response.message);
				}
			}
		});
	});

	/* Do nothing on click on non-clickable menu element */

	$('.header .menu-item-non-clickable > a').on('click', function (event) {
		event.preventDefault();
		event.stopPropagation();
	});

	/* Direct toggle for header nav items with children */
	$('.header__nav-container__bottom-menu__item--has-children > a').on('click', function(event) {
		if ($(this).closest('.layout__screen-overlay--main-menu').length > 0) {
			return;
		}

		// Only prevent navigation for menu items with "#" as href
		if ($(this).attr('href') === '#') {
			event.preventDefault();
		}

		// Always stop propagation to allow click on the link
		event.stopPropagation();

		closeAllHeaderDropdowns();

		// Add or remove active class directly on menu item
		var $parent = $(this).parent();
		$parent.toggleClass('active');

		// Toggle submenu with animation
		var $submenu = $(this).siblings('.sub-menu');
		$submenu.slideToggle(300);
	});

	// No previous mobile menu manipulation, removed to avoid conflicts

	function toggleEditionMobileMenu(event) {
		event.preventDefault();
		$('.layout__screen-overlay__nav .current-menu-ancestor > a span').toggleClass('rotate-arrow');
		$('.layout__screen-overlay__nav .sub-menu').toggle();
	}

	$('.layout__screen-overlay__nav .current-menu-ancestor > a').click(toggleEditionMobileMenu);

	/* Mobile menu - toggle submenus */
	$('.layout__screen-overlay--main-menu .menu-item-has-children > a, .layout__screen-overlay--main-menu .header__nav-container__bottom-menu__item--has-children > a').off('click mouseenter mouseleave');

	/* Mobile menu functionality - Generalized approach for all menu types */
	$(document).ready(function() {
		// Hide all submenus initially
		$('.sub-menu').hide();

		// Universal function to show all submenus for a top-level menu item
		function showAllSubmenuLevels($topMenuItem) {
			// First make sure the top menu item is active
			$topMenuItem.addClass('active');

			// Show the immediate submenu
			let $firstLevelSubmenu = $topMenuItem.children('.sub-menu');
			$firstLevelSubmenu.show();

			// For each item in the first level submenu, show its submenu
			$firstLevelSubmenu.find('> li').each(function() {
				let $secondLevelItem = $(this);

				// If this item has a submenu, show it
				if ($secondLevelItem.hasClass('menu-item-has-children') ||
					$secondLevelItem.find('> .sub-menu').length > 0) {
					$secondLevelItem.addClass('active');
					$secondLevelItem.children('.sub-menu').show();

					// For each item in the second level, show its submenu (third level)
					$secondLevelItem.find('> .sub-menu > li').each(function() {
						let $thirdLevelItem = $(this);
						if ($thirdLevelItem.hasClass('menu-item-has-children') ||
							$thirdLevelItem.find('> .sub-menu').length > 0) {
							$thirdLevelItem.addClass('active');
							$thirdLevelItem.children('.sub-menu').show();
						}
					});
				}
			});
		}

		// Handler for all top-level menu items in the mobile menu
		$('.layout__screen-overlay--main-menu .header__nav-container__bottom-menu__item > a').on('click', function(event) {
			// Always prevent navigation in mobile menu for items with submenus
			let $parent = $(this).parent();
			let hasSubmenu = $parent.hasClass('menu-item-has-children') ||
							$parent.hasClass('header__nav-container__bottom-menu__item--has-children') ||
							$parent.hasClass('header__nav-container__bottom-menu__item--non-clickable') ||
							$(this).siblings('.sub-menu').length > 0;

			if (hasSubmenu) {
				event.preventDefault();
				event.stopPropagation();

				// If this item is already active, close it
				if ($parent.hasClass('active')) {
					$parent.removeClass('active');
					$(this).siblings('.sub-menu').slideUp(300);
					return false;
				}

				// Close all other top-level menu items
				$('.layout__screen-overlay--main-menu .header__nav-container__bottom-menu__item').not($parent).removeClass('active')
					.children('.sub-menu').slideUp(300);

				// Open this menu item and show all its submenus
				$parent.addClass('active');
				$(this).siblings('.sub-menu').slideDown(300, function() {
					// After opening animation completes, show all sublevels
					showAllSubmenuLevels($parent);
				});

				return false;
			}
		});

		// Handler for submenu toggle in second level
		$('.layout__screen-overlay--main-menu .sub-menu > li > a').on('click', function(event) {
			// Skip this handler for edition menu items to avoid conflict
			if ($(this).closest('.header__nav-container__edition').length > 0) {
				return true;
			}

			// If item doesn't have submenu, let it navigate normally
			if ($(this).siblings('.sub-menu').length === 0) {
				return true;
			}

			// For items with submenu, prevent navigation and control display
			event.preventDefault();
			event.stopPropagation();

			let $parent = $(this).parent();
			let $submenu = $(this).siblings('.sub-menu');

			// Toggle active state and submenu visibility
			$parent.toggleClass('active');
			if ($parent.hasClass('active')) {
				$submenu.slideDown(300);
			} else {
				$submenu.slideUp(300);
			}

			return false;
		});

		// Show submenus of current active item
		$('.current-menu-item:not(.header__nav-container__edition *), .current-menu-ancestor:not(.header__nav-container__edition *)').each(function() {
			$(this).addClass('active');
			$(this).children('.sub-menu').show();
		});

		// When the mobile menu is toggled open, initialize all menu behaviors
		$('.js-toggle-menu').on('click', function() {
			if ($('body').hasClass('show-main-menu')) {
				// Small delay to ensure DOM is ready
				setTimeout(function() {
					// For any already active top-level items, show all their submenus
					$('.layout__screen-overlay--main-menu .header__nav-container__bottom-menu__item.active').each(function() {
						showAllSubmenuLevels($(this));
					});
				}, 300);
			}
		});
	});

	// Add document click handler to close all dropdowns when clicking outside
	$(document).on('click', function(event) {
		var $editionMenu = $('.header__nav-container__edition');
		var $loginMenu = $('.header__login-menu');
		var $target = $(event.target);
		var $mobileMenu = $('.layout__screen-overlay--main-menu');

		if ($mobileMenu.is($target) || $mobileMenu.has($target).length > 0) {
			return;
		}

		var isOutsideEdition = !$editionMenu.is($target) && $editionMenu.has($target).length === 0;
		var isOutsideLogin = !$loginMenu.is($target) && $loginMenu.has($target).length === 0;

		if (isOutsideEdition && isOutsideLogin) {
			closeAllHeaderDropdowns();
		}
	});

} );

/**
 * Sanitize and encode all HTML in a user-submitted string.
 *
 * @param   {String} str The user-submitted string.
 * @returns {String} The sanitized string.
 */
function sanitizeHTML( str ) {
	var temp = document.createElement( 'div' );
	temp.textContent = str;
	return temp.innerHTML;
};

/**
 * Get the value of the 'wordpress_selected_edition_id' cookie.
 * This function is consistent with the PHP implementation of cookie retrieval.
 * @returns {string|null} The value of the 'wordpress_selected_edition_id' cookie, or null if the cookie is not found.
 */
function getSelectedEditionId() {
	return window.regionalHomepage?.selected;
}

/**
 * Updates the text of the "Select Edition" link to match the text of the current menu item in the edition menu.
 * Preserves any icons that may be present.
 * @function updateSelectEditionText
 * @returns {void}
 */
function updateEditionText() {
	let editions_anchor = document.querySelector('.header__nav-container__edition > .menu-item-has-children > a');
	if ( ! editions_anchor ) {
		return;
	}

	// Get current page name and icon for the parent only
	let current_menu = document.querySelector('.header__nav-container__edition .current-menu-item > a');
	let current_page;
	let current_icon_html = '';

	if ( ! current_menu ) {
		let selected_edition = parseInt(getSelectedEditionId());
		let editionItems = document.querySelectorAll('.header__nav-container__edition .sub-menu li');
		editionItems.forEach(function(element) {
			let page_id = element.dataset.pageId;
			if (parseInt(page_id) === selected_edition) {
				let link = element.querySelector('a');
				if (link) {
					let icon_element = link.querySelector('.menu-icon--edition');
					if (icon_element) {
						current_icon_html = icon_element.outerHTML;
					}
					current_page = link.textContent.trim();
				} else {
					current_page = element.textContent.trim();
				}
			}
		});
	} else {
		let icon_element = current_menu.querySelector('.menu-icon--edition');
		if (icon_element) {
			current_icon_html = icon_element.outerHTML;
		}
		current_page = current_menu.textContent.trim();
	}

	let label = sanitizeHTML(current_page) ;
	let arrow_svg = '<svg class="caret-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6"><path fill="currentColor" fill-rule="nonzero" d="M4.5 6 0 0h9z"/></svg>';
	editions_anchor.innerHTML = '<div class="edition-wrap">' + current_icon_html + '</div>' + '<span>' + label + '</span>' + arrow_svg;
}

updateEditionText();

/**
 * Position and reveal the infrastructure header link once the mega-menu
 * toggle button has been rendered by the JS shared component widget.
 *
 * The button uses `right: 30px` on most viewports and `right: calc(50vw - 704px)`
 * at wide viewports, so we use getBoundingClientRect() to get actual pixel
 * positions rather than parsing CSS values. The link's right edge is placed
 * 6px to the left of the button's left edge.
 */
function initInfraLink() {
	var link = document.querySelector( '.header__infra-link' );
	var dropdown = document.getElementById( 'gs-shared-dropdown' );
	if ( !link || !dropdown ) return;

	function positionLink( btn ) {
		var container = link.offsetParent || document.body;
		var btnRect = btn.getBoundingClientRect();
		var containerRect = container.getBoundingClientRect();
		link.style.right = ( containerRect.right - btnRect.left + 6 ) + 'px';
	}

	function positionAndShow( btn ) {
		// Wait for the injected widget's styles to settle before measuring.
		setTimeout( function () {
			positionLink( btn );
			link.classList.add( 'header__infra-link--visible' );
			// Reposition on resize since the button's right offset is viewport-relative.
			var resizeTimer;
			window.addEventListener( 'resize', function () {
				clearTimeout( resizeTimer );
				resizeTimer = setTimeout( function () {
					positionLink( btn );
				}, 100 );
			} );
		}, 200 );
	}

	var existing = dropdown.querySelector( '.mega-menu-toggle' );
	if ( existing ) {
		positionAndShow( existing );
		return;
	}

	var observer = new MutationObserver( function () {
		var btn = dropdown.querySelector( '.mega-menu-toggle' );
		if ( !btn ) return;
		observer.disconnect();
		positionAndShow( btn );
	} );
	observer.observe( dropdown, { childList: true, subtree: true } );
}

initInfraLink();
